import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('../app/core/core.routes').then((m) => m.CORE_Routes),
  },
];
